/**
 * FAQ Data — Su'aalaha Inta Badan La Isweydiiyo
 *
 * Halkan ku dar ama ka badal su'aalaha iyo jawaabaha
 * q = su'aasha, a = jawaabta
 */

export const faqs = [
  {
    q: "Waa maxay GanacsiHub?",
    a: "Waa shirkad ICT ah oo Soomaaliyeed. Waxaan ganacsiyada u dhisnaa app mobile ah, website iyo nidaam lacag-bixin oo u gaar ah. Mashruuc kasta waxaan ka bilownaa fahamka baahida ganacsigaaga, kadibna waxaan dhisnaa xal loogu talagalay adiga — ma aha qaab la wada wadaago.",
  },
  {
    q: "Adeegyada aad bixisaan waa kuwee?",
    a: "App mobile ah oo Android iyo iOS labadaba ku shaqeeya, website iyo web-app, nidaam lacag-bixin oo isku xiran EVC Plus, eDahab iyo Jeeb, dashboard maamul oo aad ganacsigaaga kala socotid, iyo taageero teknikal ah oo joogto ah.",
  },
  {
    q: "Intee in le'eg ayay qaadanaysaa mashruucaygu?",
    a: "Way ku xiran tahay baaxadda mashruuca. Website caadi ah maalmo gudahood ayuu diyaar noqonayaa. App ganacsi oo dhamaystiran wuxuu qaadanayaa 2–4 toddobaad. Ka hor inta aanan bilaabin waxaan ku siinaynaa jadwal cad oo aad ogaato marxalad kasta goorta ay dhamaanayso.",
  },
  {
    q: "Immisa ayay ku kacaysaa?",
    a: "Qiimuhu wuxuu ku xiran yahay waxa aad u baahan tahay. Nagala soo xiriir WhatsApp, waxaan si bilaash ah ugala hadlaynaa baahidaada, kadibna waxaad heleysaa qiimo qoran oo aan isbeddelayn. Ma jiraan kharash qarsoon.",
  },
  {
    q: "Ma i taageeraysaan marka mashruucu dhamaado?",
    a: "Haa. Mashruuc kastaa wuxuu la socdaa muddo taageero ah — hagaajinta cilladaha, cusboonaysiinta iyo tababar shaqaalahaaga. Waxaad sidoo kale qaadan kartaa qandaraas taageero bille ah haddii aad rabto in aan sii wadno.",
  },
  {
    q: "Sideen u bilaabaa?",
    a: "Nagala soo xiriir WhatsApp ama taleefan. Waxaan yeelanaynaa kulan kooban oo aan ku fahamno waxa aad rabto, kadibna waxaan kuu diyaarinaynaa soo-jeedin qoran oo leh jadwal iyo qiimo.",
  },
];
